import type { Service } from '../types/content'

export const services: Service[] = [
  {
    number: '01',
    title: 'Creative Strategy',
    description:
      'From concept to consumer journey, we define the creative vision. Our creativity is grounded in insight, brand authenticity and audience psychology.',
    capabilities: [
      'Brand + experiential strategy',
      'Creative concepting',
      'Mood boards & narrative development',
      'Environmental + spatial design',
      'Social-first moments & storytelling',
      'Renderings & visualization',
    ],
  },
  {
    number: '02',
    title: 'Experiential Production',
    description:
      'We produce immersive environments that spark emotion, connection and conversation.',
    capabilities: [
      'Pop-up experiences',
      'Consumer activations',
      'Press & influencer events',
      'Brand installations',
      'Product launches',
      'Immersive moments & photo environments',
    ],
  },
  {
    number: '03',
    title: 'Conferences + Meetings',
    description: 'High-touch, high-impact corporate and industry events.',
    capabilities: [
      'Agenda & program development',
      'Speaker management',
      'Sponsorship integration',
      'Scenic + A/V design',
      'Registration & attendee flow',
      'Vendor management',
      'Run of show & stage direction',
      'Leadership meetings + breakouts',
    ],
  },
  {
    number: '04',
    title: 'Tradeshows',
    description:
      'We design tradeshow experiences that attract the right audience, drive meaningful conversations and deliver measurable business results.',
    capabilities: [
      'Exhibit strategy & booth design',
      'Custom fabrication & scenic environments',
      'Hospitality lounges & meeting spaces',
      'Product demonstrations & launches',
      'Lead generation experiences',
      'Meeting & appointment management',
      'Staffing & attendee engagement',
      'End-to-end production & logistics',
    ],
  },
  {
    number: '05',
    title: 'Mobile Activations + National Tours',
    description:
      'Our iconic mobile fleet brings brands to life anywhere, anytime.',
    capabilities: [
      'Single & multi-city tours',
      'Mobile pop-up shops',
      'Sampling trucks',
      'Food & beverage activations',
      'Retail + OOH tie-ins',
      'Staffing & brand ambassadors',
      'Permitting, routing & logistics',
      'National transport',
    ],
  },
  {
    number: '06',
    title: 'B2B Events + Internal Initiatives',
    description:
      'Programs designed to inspire, reward and align internal and partner audiences.',
    capabilities: [
      'Presidents Clubs & incentive trips',
      'Sales kickoffs + retreats',
      'Leadership summits + offsites',
      'Internal culture events',
      'Team-building experiences',
      'Content development + program architecture',
    ],
  },
  {
    number: '07',
    title: 'Fabrication + Build Services',
    description:
      'Custom spaces, scenic builds, experiential structures and branded environments.',
    capabilities: [
      'Scenic walls',
      'Display shelving',
      'Retail pop-ups',
      'Mobile carts + custom builds',
      'Photo moments',
      'Stage + scenic design',
      'Custom fabrication management',
    ],
  },
  {
    number: '08',
    title: 'Logistics + Operations',
    description: 'A seamless operational engine behind every experience.',
    capabilities: [
      'Routing & timeline management',
      'DOT compliance',
      'Shipping + freight',
      'Storage & asset management',
      'On-site production teams',
      'Permitting',
      'Staffing & training',
      'Inventory oversight',
    ],
  },
]
